import React from 'react'

export default {
  forSale: true,
  viewable: true,
  title: 'Æðaroddi 40-49',
  key: 'aedaroddi-40-49',
  rect: {
    className: 'bg-body text-dark badge-arrow',
    props: {
      x: 5760,
      y: 1330,
      width: 660,
      height: 135,
    },
  },
  path: {
    d: 'M6816.4,1395.91L5741.83,2514c-2.66,2.77-7.05,2.88-9.85,0.25l-755.52-711.42c-2.85-2.68-2.95-7.17-0.22-9.97L6698.94,18.5c2.69-2.77,7.12-2.84,9.89-0.15l410.2,396.97c2.73,2.65,2.85,6.99,0.27,9.79l-609.58,658.53c-2.6,2.81-2.46,7.18,0.3,9.82L6816.19,1386C6818.99,1388.68,6819.08,1393.12,6816.4,1395.91z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/aedaroddi/aedaroddi-40-49.jpg'),
      width: 3248,
      height: 2333,
    },
    list: [
      {
        lod: 'aedaroddi-40',
        d: 'm1142.9 2022.51-128.67 124.39-220.37-227.94 128.67-124.39 220.37 227.94z',
      },
      {
        lod: 'aedaroddi-41',
        d: 'M440.37 2039.56 136 1761.11l243.72-255.85 304.37 278.45-243.72 255.85z',
      },
      {
        lod: 'aedaroddi-43',
        d: 'm688.95 1775.72-304.37-278.45 243.72-255.85 304.37 278.45-243.72 255.85z',
      },
      {
        lod: 'aedaroddi-45',
        d: 'm937.48 1511.83-304.37-278.45 243.72-255.85 304.37 278.45-243.72 255.85z',
      },
      {
        lod: 'aedaroddi-47',
        d: 'M1186 1247.93 881.63 969.48l243.72-255.85 304.37 278.45L1186 1247.93z',
      },
      {
        lod: 'aedaroddi-42',
        d: 'm1354.23 1933.36-304.37-278.45 243.72-255.85 304.37 278.45-243.72 255.85z',
      },
      {
        lod: 'aedaroddi-44',
        d: 'm1602.75 1669.47-304.37-278.45 243.72-255.85 304.37 278.45-243.72 255.85z',
      },
      {
        lod: 'aedaroddi-49',
        d: 'm1958.45 424-398.16 107.89-85.52-342.85 398.16-107.89L1958.45 424z',
      },
    ],
  },
}
